function openGiftcardStatusModal({
  header,
  info,
  success,
  lastFour,
  email,
}) {
  const resendGiftcardStatusModal = document.getElementById('modal-resend-gift-card-status');
  const resendGiftcardStatusModalHeader = resendGiftcardStatusModal.querySelector('.modal-content-header');
  const resendGiftcardStatusModalInfo = resendGiftcardStatusModal.querySelector('.modal-content-info');
  const closeButtonWrapper = resendGiftcardStatusModal.querySelector('.close-button-wrapper');
  let sanitizedInfo = info;
  if (success) {
    closeButtonWrapper.classList.remove('hidden');
    sanitizedInfo = sanitizedInfo.replace('(@giftcardNumber)', lastFour);
    sanitizedInfo = sanitizedInfo.replace('(@supplierEmail)', email);
  } else {
    closeButtonWrapper.classList.add('hidden');
  }
  resendGiftcardStatusModalHeader.textContent = header;
  resendGiftcardStatusModalInfo.textContent = sanitizedInfo;
  resendGiftcardStatusModal.setAttribute('open', true);
}

function closeGiftcardStatusModal() {
  const resendGiftcardStatusModal = document.getElementById('modal-resend-gift-card-status');
  resendGiftcardStatusModal.removeAttribute('open');
}

async function resendGiftCardEmail(uuid, lastFour, email) {
  const giftcard = await giftcardResendEmail(uuid);

  if (!giftcard) {
    openGiftcardStatusModal({
      header: ResendGiftCardModalContent.failHeader,
      info: ResendGiftCardModalContent.failInfo,
      success: false,
    });
  } else {
    openGiftcardStatusModal({
      header: ResendGiftCardModalContent.successHeader,
      info: ResendGiftCardModalContent.successInfo,
      success: true,
      lastFour,
      email,
    })
  }
};

const closeButton = document.querySelector('#modal-resend-gift-card-status .close-button-wrapper > button');
closeButton.addEventListener('click', closeGiftcardStatusModal);
